import { useState } from "react";
import { X, MessageCircle, Mail, BookOpen } from "lucide-react";
import { publicDocsUrl } from "@/lib/docs";

export default function SupportButton() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 w-72 p-5 animate-fade-in-up">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-semibold text-slate-900 text-sm">Soporte emite.do</h3>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-600 cursor-pointer">
              <X size={16} />
            </button>
          </div>
          <p className="text-slate-500 text-xs mb-4 leading-relaxed">
            ¿Necesitas ayuda con la integración o tienes alguna pregunta fiscal?
          </p>
          <div className="space-y-2">
            <a
              href="mailto:soporte@ecfservice.do"
              className="flex items-center gap-2 w-full bg-blue-800 text-white text-sm font-medium px-4 py-2.5 rounded-xl hover:bg-blue-700 transition-colors cursor-pointer"
            >
              <Mail size={16} />
              Enviar email
            </a>
            <a
              href={publicDocsUrl()}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 w-full bg-slate-50 text-slate-700 text-sm font-medium px-4 py-2.5 rounded-xl hover:bg-slate-100 transition-colors cursor-pointer"
            >
              <BookOpen size={16} />
              Ver documentación
            </a>
          </div>
          <p className="text-slate-400 text-xs mt-3 text-center">Respuesta en &lt; 4h en días hábiles</p>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="w-12 h-12 flex items-center justify-center bg-blue-800 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all cursor-pointer hover:scale-105"
      >
        {open ? <X size={20} /> : <MessageCircle size={20} />}
      </button>
    </div>
  );
}